module.exports = __webpack_public_path__ + "static/get_connected-be1be22e266a6fc0bdc252dea15511b9.png";